import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { CampaignDetailPage } from '@/components/strategy-detail/campaigns/campaign-detail/campaign-detail-page';
import { loadNamespaces } from '@/lib/i18n/i18n';

const paramsSchema = z.object({
  strategyId: z.coerce.number().int().positive(),
  campaignId: z.coerce.number().int().positive(),
});

export const Route = createFileRoute(
  '/_authenticated/strategies/$strategyId/campaigns/$campaignId',
)({
  loader: () => loadNamespaces('assets', 'strategy'),
  params: {
    parse: (raw) => paramsSchema.parse(raw),
    stringify: ({ strategyId, campaignId }) => ({
      strategyId: String(strategyId),
      campaignId: String(campaignId),
    }),
  },
  staticData: {
    title: 'route.campaign.title',
    // Index and this leaf are siblings under the `$strategyId` layout, not
    // ancestor/descendant — the index route's `messageContext` never reaches
    // here, so Copilot would otherwise fall back to workspace-scoped grounding.
    messageContext: { context_type: 'strategy', idParam: 'strategyId' },
  },
  component: CampaignDetailRoute,
});

function CampaignDetailRoute(): React.ReactElement {
  const { strategyId, campaignId } = Route.useParams();
  return <CampaignDetailPage strategyId={strategyId} campaignId={campaignId} />;
}
